import type { CreditApplication } from '@paguz/contracts';
import { useQuery } from '@tanstack/react-query';
import { getCurrentApplication } from '../../api/origination.ts';
import { queryKeys } from '../../api/query-client.ts';

/** Hay algo "en vivo": documentos en revisión o decisión pendiente. */
export function isLive(application: CreditApplication | null | undefined): boolean {
  if (!application) return false;
  return (
    application.phase === 'SUBMITTED' ||
    (application.phase === 'DECISION' && application.offer === null) ||
    application.documents.some((d) => d.status === 'UPLOADED' || d.status === 'ANALYZING')
  );
}

/** Solicitud activa; se refresca sola mientras hay revisión documental o decisión en curso. */
export function useCurrentApplication() {
  return useQuery({
    queryKey: queryKeys.application,
    queryFn: getCurrentApplication,
    refetchInterval: (query) => (isLive(query.state.data) ? 2000 : false),
  });
}
